import MaterialTable, { MTableBody } from "material-table";
import React, { forwardRef } from "react";

import ScrollContainer from "./tables/ScrollContainer";
import tableIcons from "./tables/icons";

import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { dense_theme } from "./tables/themes";

import { flatMap } from "lodash";

export default React.memo(function ResidueList(props) {
  const data = flatMap(props.residues, o =>
    o.residues.map(r => ({ id: o.id, ...r }))
  );

  return (
    <MuiThemeProvider theme={dense_theme}>
      <MaterialTable
        columns={[
          {
            title: "Model",
            field: "id",
            defaultGroupOrder: 1,
            lookup: props.model_labels
          },
          { title: "Chain", field: "chain", defaultGroupOrder: 2 },
          { title: "Name", field: "resn", grouping: false },
          { title: "#", field: "resi", grouping: false }
        ]}
        title="" //Residues'
        icons={tableIcons}
        options={{
          grouping: true,
          paging: false,
          defaultExpanded: true
        }}
        components={{
          Groupbar: props => "",
          Header: props => <thead />,
          Container: props => (
            <ScrollContainer>{props.children}</ScrollContainer>
          )
          // Container: props => <div>{props.children}</div>,
        }}
        {...props}
        data={data}
      />
    </MuiThemeProvider>
  );
});
